export const BLOG_CONSTS = {
    GET_BLOGS: "GET_BLOGS",
    GET_BLOGS_IN_MODAL: "GET_BLOGS_IN_MODAL",
    ADD_BLOG: "ADD_BLOG",
    UPDATE_BLOG: "UPDATE_BLOG",
    DELETE_BLOG: "DELETE_BLOG",
};
